export const GET_SELECTED_DAMS = "GET_SELECTED_DAMS";
export const SET_SELECTED_DAMS = "SET_SELECTED_DAMS";
export const GET_LOG_ENTRIES = "GET_LOG_ENTRIES";
export const FETCH_LOG_ENTRIES = "FETCH_LOG_ENTRIES";
export const SET_LOG_ENTRIES = "SET_LOG_ENTRIES";
export const GET_TOTAL_ENTRIES = "GET_TOTAL_ENTRIES";
export const GET_PAGINATION_PAGE = "GET_PAGINATION_PAGE";
export const SET_PAGINATION_PAGE = "SET_PAGINATION_PAGE";
export const RESET_LOG_DATA = "RESET_LOG_DATA";